import React, { Component } from "react";
import Slider from "react-slick";
import PropTypes from 'prop-types'
import Image from 'next/image'

class ProductSlider extends Component {
  render() {
    const settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1500,
      autoplaySpeed: 1000,
      swipe: false,
      pauseOnFocus: false,
      arrows: false,
      dots: false,
      className: 'product-slider center',
      pauseOnHover: false,
    };
    const slider_data = this.props.slider_data
    // null/undefined = live fetch still in flight — keep height so Start doesn't jump.
    if (slider_data == null) {
      return (
        <div
          className="home-slick product-slick product-slick--placeholder"
          aria-hidden="true"
        />
      )
    }
    let product_array = []
    let index = 0
    for (let product in slider_data) {
      // Only the first few slides can be above-the-fold; marking every image
      // priority competed with the logo for LCP bandwidth.
      const eager = index < 4
      product_array.push(
        <div key={product+'product-slider'}>
          <a
            href={slider_data[product].url}
            target="_blank"
            rel="noopener noreferrer sponsored nofollow"
          >
            <Image
              src={slider_data[product].image}
              alt={slider_data[product].name || 'Product'}
              priority={eager}
              loading={eager ? undefined : 'lazy'}
              width={'85'}
              height={'85'}
              sizes="85px"
              quality={70}
              className='product-slide'
            />
          </a>
        </div>
      )
      index += 1
    }
    if (product_array.length <= 5) {
      return (null)
    }
    return (
      <div className="home-slick product-slick">
        <Slider {...settings}>
          {product_array}
        </Slider>
      </div>
    );
  }
}

ProductSlider.propTypes = {
  // null = loading (placeholder); array = loaded (empty/short hides strip)
  slider_data: PropTypes.array,
}

export default ProductSlider
